<div class="container">
  <div
    [class]="columns === 3 ? 'grid_3' : 'grid_4'"
    *ngFor="let teaser of teasers"
  >
    <hdi-teaser
      [type]="teaser.type || teaserType"
      [headline]="teaser.headline || ''"
      [description]="teaser.description || ''"
      [imageSrc]="teaser.imageSrc"
      [imageBorder]="teaser.imageBorder || false"
      [target]="teaser.target"
      [label]="teaser.label ?? '' | capitalize"
      [badges]="teaser.badges || []"
    ></hdi-teaser>
  </div>
</div>
